<script>
import Menu from '/src/components/header.vue';
import Rodape from '/src/components/rodape.vue';

export default {
    name: 'Sede',
    components: {
        Menu,
        Rodape
    }

}
</script>

<template>
    <Menu></Menu>
    <div class="sede">
        <div class="mainsede">
            <p class="titulo">SEDE FABRIL</p>
            <p class="subtitulo1">Capacidade de 85 toneladas/mês</p>

            <p class="subtitulo2">Equipamentos de Movimentação:</p>
            <ul>

            <li>Capacidade de Elevação</li>
                <li>Pórtico com capacidade para 5 toneladas</li>
                    <li>Pórtico com capacidade para 3 toneladas</li>
            </ul>
            
            <p class="subtitulo2">Área Fabril Total: 2.900 m²</p>
            <ul>
                <li>Área de Fabricação: 2.000 m²</li>
                    <li>Área de Usinagem: 900 m²</li>
                        <li>Área de Apoio (Base, Almoxarifado, Salas): 490 m²</li>
                </ul>
            <p class="text2">Com infraestrutura robusta e equipamentos de alta capacidade, estamos preparados para atender às demandas
            mais exigentes com eficiência e precisão.</p>
        </div>
    </div>
    <Rodape></Rodape>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
.sede {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    min-height: 65vh;
}

.menu {
    position: relative;
    width: 100%;
    z-index: 1;
}

.mainsede{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 95%;
}

.titulo {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 1rem 0rem;
    color: #2e74c4;
}

.subtitulo1 {
    font-size: 1rem;
    font-weight: bold;
    margin: 0.5rem 0rem;
    color: #444;
}
.subtitulo2 {
    font-size: 1.1rem;
    font-weight: bold;
    margin: 1.2rem 0rem;
    color: #444;
}

.text2 {
    text-align: justify;
    font-size: 1rem;
    color: #444;
    margin: 2rem 0rem;
    text-align: center;
}
li {
    text-align: justify;
    font-size: 0.9rem;
    color: #444;
    margin: 0.3rem 0rem;
}
.rodape {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}
}
@media (min-width: 901px) {
.sede {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    min-height: 53.5vh;
}

.menu {
    position: relative;
    width: 100%;
    z-index: 1;
}

.mainsede{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 70%;
}

.titulo {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 1rem 0rem;
    color: #2e74c4;
}

.subtitulo1 {
    font-size: 1.3rem;
    font-weight: bold;
    margin: 0.5rem 0rem;
    color: #444;
}
.subtitulo2 {
    font-size: 1.1rem;
    font-weight: bold;
    margin: 1.5rem 0rem;
    color: #444;
}

.text2 {
    text-align: justify;
    font-size: 1.3rem;
    color: #444;
    margin: 2rem 0rem;
    text-align: center;
}
li {
    text-align: justify;
    font-size: 1rem;
    color: #444;
    margin: 0.3rem 0rem;
}
.rodape {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
}
}
</style>